"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const contactItems = [{
  id: "email",
  title: "E-Mail",
  value: "office@cup4us.at",
  icon: Mail,
  actionText: "E-Mail schreiben",
  actionLink: "mailto:office@cup4us.at",
  isPrimary: false
}, {
  id: "whatsapp",
  title: "WhatsApp",
  value: "+43 660 9337667",
  icon: Phone,
  actionText: "WhatsApp Chat",
  actionLink: "https://wa.me/43660933776767",
  isPrimary: true
}, {
  id: "location",
  title: "Anrufen",
  value: "Direkter Kontakt",
  icon: Phone,
  actionText: "Jetzt anrufen",
  actionLink: "tel:+43660933776767",
  isPrimary: false
}];
export default function ContactInfo() {
  return <section data-section-id="247933" id="contactcalltoaction" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Kontaktieren Sie uns
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg">
            Wir freuen uns auf Ihre Anfrage für nachhaltige Mehrwegbecher. Wählen Sie Ihren bevorzugten Kanal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {contactItems.map((item, i) => {
          const Icon = item.icon;
          return <Card key={item.id} data-index={i} className={`text-center h-full flex flex-col transition-all duration-300 rounded-lg ${item.isPrimary ? "border-secondary/30 shadow-xl hover:shadow-2xl relative overflow-hidden bg-accent/50 backdrop-blur-sm" : "border-border shadow-md hover:shadow-lg bg-card"}`}>
                {item.isPrimary && <div className="absolute top-0 left-0 w-full h-1 bg-secondary" />}
                <CardHeader className="pb-2 items-center">
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-4 ${item.isPrimary ? "bg-secondary text-secondary-foreground shadow-md" : "bg-secondary/10 text-secondary"}`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="font-default text-xl text-foreground">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow flex flex-col justify-between">
                  <p className="font-default text-muted-foreground mb-6 font-medium">
                    {item.value}
                  </p>
                  <Button variant={item.isPrimary ? "default" : "outline"} asChild className="w-full mt-auto rounded-full font-default">
                    <Link to={item.actionLink} newTab={item.id !== "email"}>
                      {item.actionText}
                    </Link>
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}